// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dj-a";
export var fulfillmentFormRail = "_dj-9";
export var headerTitleRow = "_dj-c";
export var orderDetailsWrapper = "_dj-7";
export var orderLinkTrigger = "_dj-2";
export var paymentInformationGrid = "_dj-h";
export var paymentSummaryColumn = "_dj-i";
export var shipmentContainer = "_dj-b";
export var shipmentDetailsMainPane = "_dj-8";
export var shipmentNavigationCard = "_dj-5";
export var shipmentNavigationRail = "_dj-3";
export var shipmentNavigationRailHeader = "_dj-4";
export var shipmentSummaryFact = "_dj-e";
export var shipmentSummaryGrid = "_dj-d";
export var shipmentSummaryMetadataRow = "_dj-f";
export var shipmentSummaryTags = "_dj-g";
export var shipmentWorkspace = "_dj-0";
export var shipmentWorkspaceContent = "_dj-6";
export var shipmentWorkspaceHeader = "_dj-1";